import {Injectable} from '@angular/core';
import {LoggerUserService} from '@mydocma/common/src/lib/logger';
import {Observable, of} from 'rxjs';

@Injectable()
export class MmLoggerUserService implements LoggerUserService {

  constructor() {

  }

  getUserSerialization(): Observable<string> | string {
    return of("s.neumann@edr-software.com");
  }
}
